import { render, staticRenderFns } from "./CardFolder.vue?vue&type=template&id=d66bdf02"
import script from "./CardFolder.vue?vue&type=script&lang=js"
export * from "./CardFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d66bdf02')) {
      api.createRecord('d66bdf02', component.options)
    } else {
      api.reload('d66bdf02', component.options)
    }
    module.hot.accept("./CardFolder.vue?vue&type=template&id=d66bdf02", function () {
      api.rerender('d66bdf02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Folder/CardFolder.vue"
export default component.exports